<template>
  <div class="display-order">
    <div class="action-button-bar ma-3">
      <v-btn
        class="action-button"
        @click="print()"
        color="primary"
        :loading="loading"
        :disabled="loading"
      >Print</v-btn>
      <!--
      <v-btn class="action-button" disabled>Re-send Email (Coming Soon)</v-btn>
      -->
    </div>
    <div>Email Preview:</div>
    <div class="email-preview-container">
      <iframe id="email-preview" name="email-preview" :src="src" @load="onPreviewLoad()"></iframe>
      <v-progress-circular v-if="loading" indeterminate size="64" class="email-preview-spinner"></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  created: function() {},
  components: {},
  data: () => ({
    loading: true
  }),
  computed: {
    orderId: function() {
      return this.$route.params.orderId;
    },
    src: function() {
      var baseUrl = `${window.location.protocol}//${window.location.hostname}`;
      return `${baseUrl}/Manufacturer/${this.$store.state.manufacturerId}/PreviewAvenueEmail?order_guid=${this.$route.params.orderId}`;
    }
  },
  methods: {
    print: function() {
      //https://stackoverflow.com/questions/9616426/javascript-print-iframe-contents-only/9616706
      window.frames["email-preview"].focus();
      window.frames["email-preview"].print();
    },
    onPreviewLoad: function() {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.display-order {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
}

iframe {
  width: 800px;
  max-width: 90vw;
  height: 80vh;
}

.action-button {
  margin: 10px;
}

.email-preview-container {
  position: relative;
}

.email-preview-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
